import { THIRD_PARTY_CHARGER_OFFER_SUBTYPE_ID } from 'site-modules/shared/components/incentives/incentives-wizard/constants/subtype-ids';

export const isTreehousePromoIncentive = ({ grantor, subtypeId }) =>
  subtypeId === THIRD_PARTY_CHARGER_OFFER_SUBTYPE_ID && grantor === 'Treehouse';
